__turbopack_context__.v({
  "sticky": "LeasingStickyInfo-module__EfCrNa__sticky",
  "stickyInfo": "LeasingStickyInfo-module__EfCrNa__stickyInfo",
  "stickyInfoCompact": "LeasingStickyInfo-module__EfCrNa__stickyInfoCompact",
});
